var Request = require('../../helper/request');
var queryString = require('query-string');

function User(app, companyId){
	var self = this;
	self.request = new Request(app);
	self.companyId = companyId;

	self.routes = {
		index: {
			url: '/company/'+self.companyId+'/search/user?name=:query',
			method: 'GET'
		},
		multiFieldSearchIndex: {
			url: '/company/'+self.companyId+'/search/user?:query',
			method: 'GET'
		},
		columnIndex: {
			url: '/company/'+self.companyId+'/search/user?field=:field&name=:query',
			method: 'GET'
		},
		location: {
			url: '/company/'+self.companyId+'/search/user?lat=:lat&long=:long&radius=:radius',
			method: 'GET'
		},
		multiFieldIndex: {
			url: '/company/'+self.companyId+'/search/user',
			method: 'GET'
		}
	};
}

User.prototype.index = function(query){
	var self = this;
	var uri = self.routes.index.url.replace(':query', query);
	return self.request.get(uri);
}

User.prototype.multiFieldSearchIndex = function(query){
	var self = this;
	var uri = self.routes.multiFieldSearchIndex.url.replace(':query', query);
	return self.request.get(uri);
}

User.prototype.columnIndex = function(field, query){
	var self = this;
	var uri = self.routes.columnIndex.url.replace(':field', field).replace(':query', query);
	return self.request.get(uri);
}

User.prototype.location = function(lat, long, radius){
	var self = this;
	var uri = self.routes.location.url.replace(':lat', lat)
							.replace(':long', long)
							.replace(':radius', radius);
	return self.request.get(uri);
}

/*
* Fields: [first_name, last_name, email, email_privacy, phone, phone_privacy, 
*					tags(array), skills(array), user_specifications(array)]
*/
User.prototype.multiFieldIndex = function(fields){
	var self = this;
	var uri = self.routes.multiFieldIndex.url + "?" + queryString.stringify(fields, {arrayFormat: "bracket"});
	return self.request.get(uri);
}

module.exports = User;